var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"labels"},[_c('h1',[_vm._v("labels Component")]),_vm._v(" "+_vm._s(_vm.respData)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }